
import BScroll from "better-scroll";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import Cookies from "js-cookie";
export default {
name: "bookRecomd",
components: {
Group,
XInput,
XButton,
XNumber,
Toast
},
data() {
return {
toast: false,
bookNum: 1,
bookname: "",
author: "",
ISBN: "",
dzzhao: "",
tips: "",
bscroll: ""
};
},
computed: {
canValidate() {
return !(this.bookNum && this.author && this.ISBN);
}
},
mounted() {
this.initScroll();
},
methods: {
initScroll() {
let wrapper = document.querySelector(".bookRecomd");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
},
reset() {
/*重置*/
this.bookNum = 1;
this.bookname = "";
this.author = "";
this.ISBN = "";
},
validate() {
/*验证-提交*/
if (this.bookname == "") {
this.toast = true;
this.tips = "请填写书名";
return;
} else if (this.author == "") {
this.toast = true;
this.tips = "请填写作者";
return;
} else if (this.ISBN == "") {
this.toast = true;
this.tips = "请填写ISBN";
return;
}
this.handleBookRecommend();
},
handleBookRecommend() {
this.$http("post", "/book/recommend", {
openId: Cookies.get("openId"),
bookName: this.bookname,
author: this.author,
isbn: this.ISBN,
readerBarcode: Cookies.get("dzzhao"),
buyNum: this.bookNum
})
.then(res => {
this.$vux.loading.hide();
this.toast = true;
this.tips = res.message;
})
.catch(() => {
this.$vux.loading.hide();
});
}
}
};
